<template>
  <div class="home">
    <shell>
      <template v-slot:default>
        <div class="lg:w-full container m-auto">
          <div class="w-full lg:w-1/2 m-auto relative">
            <div class="px-2">
              <div class="m-auto">
                <div class="w-full">
                  <div>
                    
                  </div>

                  <div class="pb-4 text-lg font-bold flex justify-between items-center"><div>Records To-Go</div>
                    <div class="my-4 py-4 rounded text-gray-darker">
                      <router-link to="/new-export" class="text-white bg-full-blue rounded p-2 text-sm no-underline">New...</router-link>
                    </div></div>
                  <div v-if="exports.length === 0">
                    <div class="my-4 p-4 bg-gray-lighter rounded text-gray-darker">
                      No exports yet...
                    </div>

                  </div>

                  <router-link
                    :to="'/exports/' + e.id"
                    v-else v-for="e in exports" class="bg-white text-black mb-4 p-4 rounded block flex justify-between items-center no-underline">
                    <div>
                      <div>{{e.name}}</div>
                      
                      <div class="text-lg pb-2 no-underline block font-bold">
                        <div v-if="e.type == 'STATIC_SITE'" class="pb-2">
                          Static Site: <span class="font-normal" v-if="e.params.title">{{e.params.title}}</span>
                        </div>
                        <div v-else>
                          Raw Data JSON
                        </div>
                      </div>

                      

                      <!-- <pre>{{e.params}}</pre> -->

                      <div v-if="e.type == 'STATIC_SITE'" class="pb-2">
                        <div><span class="bg-light-yellow text-xs py-1 px-2 font-bold font-mono">{{e.params.baseFolder}}</span></div>
                      </div>
                      <div v-else>
                        
                      </div>

                      <div class="text-sm">{{renderDate(e.created_at)}}</div>
                    </div>
                    <div class="text-sm py-2">
                      <div v-if="e.is_complete && e.is_success" class="text-green font-bold">Done</div>

                      <div v-else-if="e.is_complete && !e.is_success" class="text-red">Export Failed</div>
                      <div v-else>Generating export...</div>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </shell>
  </div>
</template>

<script>
 import {DateTime} from 'luxon';
 import {mapState, mapActions} from 'vuex';
 import eventBus from '@/eventBus';
 import Shell from '@/components/Shell';

 import api from '@/api'

 export default {
   name: 'exports',
   props: {
     path: {
       type: String,
       default: ''
     },
   },

   data () {
     return {
       SERVER: process.env.VUE_APP_API_URL,
       exports: [],
       error: ''
     }
   },

   components: {Shell},

   computed: {
     ...mapState({
       member: state => state.member,
     }),
   },

   async created () {
     const {res, err} = (await api.getExports())

     if (err) {
       this.error = err.response.data
     }

     this.exports = res
   },

   methods: {
     renderDate(d) {
       return DateTime.fromISO(d).toFormat('LLL dd, yyyy t')
     }
   },
 }
</script>

<style scoped>
 
</style>


